import { createContext } from "react";

import { ReasonForVisitHelper } from "./ReasonForVisitHelper.ts";

export const ReasonForVisitContext = createContext<ReasonForVisitHelper>(
  {} as ReasonForVisitHelper
);
